<div
  class="owner-data-card"
  [class.disabled]="notClaimed"
  (click)="notClaimed && onViewData()"
>
  <div class="owner-info-cont">
    @if (
      !notClaimed && ticket.eventAttendee && ticket.eventAttendee.getName()
    ) {
      <div class="ticket-item-user-data">
        <i class="fa-regular fa-user icon-medium"></i>
        <div class="ticket-item-user-data-value">
          {{ ticket.eventAttendee.getName() }}
        </div>
      </div>
    } @else {
      <div
        class="ticket-item-user-data data-missing"
        [class.disabled]="notAssigned"
      >
        <i class="fa-regular fa-user icon-medium"></i>
        <div class="ticket-item-user-data-value">
          @if (ticket.eventAttendee) {
            {{
              ticket.eventAttendee.getName() || "APP.DATA_MISSING" | translate
            }}
          } @else {
            {{ "APP.DATA_MISSING" | translate }}
          }
        </div>
      </div>
      <div class="ticket-order-warning-cont">
        <i
          class="fa-regular fa-circle-exclamation icon-regular warning-icon"
        ></i>
      </div>
    }
  </div>
  @if (ticket.eventAttendee) {
    <button
      class="btn btn-sm btn-primary pop-color"
      [class.disabled]="notClaimed"
      (click)="onViewData()"
    >
      @if (!notClaimed) {
        {{ "APP.TICKETS_DASHBOARD.VIEW_DATA" | translate }}
      } @else {
        {{ "APP.TICKETS_DASHBOARD.CLAIM_PENDING" | translate }}
      }
    </button>
  } @else {
    <button
      class="btn btn-sm btn-primary pop-color"
      (click)="onForwardTicket()"
    >
      {{ "APP.TICKETS_DASHBOARD.ASSIGN_TICKET" | translate }}
    </button>
  }
</div>
